export class AddToCartEvent extends Event {
  #sku = ""
  #quantity = 0
  #done = null
  get sku() {
    return this.#sku
  }
  get quantity() {
    return this.#quantity
  }
  get done() {
    return this.#done
  }

  constructor(name, options, sku, quantity, done) {
    super(name, options)
    this.#sku = sku
    this.#quantity = quantity
    this.#done = done
  }
}

export class AppStartEvent extends Event {
  #products = []
  #done = null
  get done() {
    return this.#done
  }
  get products() {
    return this.#products
  }
  constructor(name, options, products, done) {
    super(name, options)
    this.#products = products
    this.#done = done
  }
}

export class AddToCartCompletedEvent extends Event {
  #done = null
  get done() {
    return this.#done
  }
  constructor(name, options, done) {
    super(name, options)
    this.#done = done
  }
}

export class ItemStackedEvent extends Event {
  #done = null
  #item = null
  get item() {
    return this.#item
  }
  get done() {
    return this.#done
  }
  constructor(name, options, item, done) {
    super(name, options)
    this.#item = item
    this.#done = done
  }
}

export class SelectionReviewedEvent extends Event {
  #items = []
  #done = null
  get items() {
    return this.#items
  }
  get done() {
    return this.#done
  }
  constructor(name, options, items, done) {
    super(name, options, items, done)
    this.#items = items
    this.#done = done
  }
}

export class ItemsUnstackedEvent extends Event {
  #items = []
  #done = null
  get items() {
    return this.#items
  }
  get done() {
    return this.#done
  }
  constructor(name, options, items, done) {
    super(name, options)
    this.#items = items
    this.#done = done
  }
}

export class ShareThisClickedEvent extends Event {
  #shareLink = ""
  #products = []
  get shareLink() {
    return this.#shareLink
  }
  get products() {
    return this.#products
  }
  constructor(name, options, shareLink, products) {
    super(name, options)
    this.#shareLink = shareLink
    this.#products = products
  }
}
